const reducer = (state, action) => {
    if (action.type === 'ADD_ITEM') {
        let e = action.payload;
        if (e.target.parentElement.classList.contains('store-item-icon')) {
            let name = e.target.parentElement.nextElementSibling.textContent;
            let selectedPlayer;
            state.players[0].forEach(player=> {
                    if (name === player.name) {
                        selectedPlayer = player;
                        return;
                    }
                });
            if (!state.dropdown.includes(selectedPlayer)) {
                if (state.dropdown.length < 5 && (state.total + selectedPlayer.price) < 17) 
                    return { ...state, dropdown: state.dropdown.concat(selectedPlayer) } 
                else
                    return { ...state}
            } else {return {...state}}
        }else{ return {...state}}
    }
        
    if (action.type === 'SEARCH_ITEM') {
        if (action.payload.word !== '') {
            state.players[0].forEach(player => {
                let nameText = player.name.toLocaleLowerCase();
                if (nameText.includes(action.payload.word.toLocaleLowerCase())) {
                    player.visibility = true; 
                } else {
                    player.visibility = false;
                }
            });
        } else {
            state.players[0].forEach(player => {
                player.visibility = true;
            });
        }
        return {...state}
    }

    if (action.type === 'CALCULATE_TOTAL') {
        let total = 0;
        state.dropdown.forEach(player => {
            total += player.price;
        });
        return {...state, total: total}
    }

    if (action.type === 'DELETE_ITEM') {
        const newDropdownPlayers = state.dropdown.filter(el => el.name !== action.payload)
        return {...state, dropdown: newDropdownPlayers}
    }

    if (action.type === 'CLEAR_ITEMS') {
        return {...state, dropdown: []}
    }

    if (action.type === 'CHANGE_PAGE') {
        return {...state, page: action.payload}
    }

    if (action.type === 'CHECK') {
        return {...state, checkout: true}
    }
}

export default reducer